import { TRIAL_DURATION_DAYS, MIDPOINT_THRESHOLD_DAYS, } from "../shared/constants.js";
const TOUCH_POINT_START = {
    step: 1,
    titleKey: "reverse_trial_start_title",
    bodyKeys: [
        { key: "reverse_trial_start_body_1", style: "paragraph" },
        { key: "reverse_trial_start_body_2", style: "paragraph" },
    ],
    buttonKey: "reverse_trial_start_button",
    hasTarget: false,
    minElapsedDays: 0,
    learnMore: "reverse_trial_learn_more",
};
const TOUCH_POINT_MIDPOINT = {
    step: 2,
    titleKey: "reverse_trial_midpoint_title",
    bodyKeys: [{ key: "reverse_trial_midpoint_body", style: "paragraph" }],
    buttonKey: "reverse_trial_premium_button",
    hasTarget: true,
    minElapsedDays: MIDPOINT_THRESHOLD_DAYS,
};
const TOUCH_POINT_ENDED = {
    step: 3,
    titleKey: "reverse_trial_ended_title",
    bodyKeys: [{ key: "reverse_trial_ended_body", style: "paragraph" }],
    buttonKey: "reverse_trial_premium_button",
    hasTarget: true,
    minElapsedDays: TRIAL_DURATION_DAYS,
};
const TOUCH_POINTS = [
    TOUCH_POINT_START,
    TOUCH_POINT_MIDPOINT,
    TOUCH_POINT_ENDED,
];
export const LAST_TOUCH_POINT_STEP = TOUCH_POINTS[TOUCH_POINTS.length - 1].step;
export function resolveNextTouchPoint(lastShownStep, elapsedDays) {
    return TOUCH_POINTS.slice()
        .reverse()
        .find((config) => lastShownStep < config.step && elapsedDays >= config.minElapsedDays);
}
